import styled, { css } from "styled-components";

import { colorsPalettes, setElevation, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import {
    MAX_TEXTAREA_HEIGHT_PX,
    SEND_BUTTON_BORDER_RADIUS_PX,
    SEND_BUTTON_SIZE_PX,
    SEND_GRADIENT_ACTIVE_END_COLOR,
    SEND_GRADIENT_ACTIVE_START_COLOR,
    SEND_GRADIENT_ANGLE,
    SEND_GRADIENT_END_COLOR,
    SEND_GRADIENT_END_OFFSET,
    SEND_GRADIENT_HOVER_END_COLOR,
    SEND_GRADIENT_HOVER_START_COLOR,
    SEND_GRADIENT_START_COLOR,
    SEND_GRADIENT_START_OFFSET,
    STOP_ICON_BORDER_RADIUS_PX,
    STOP_ICON_SIZE_PX,
} from "./constants";

export const SEND_GRADIENT = css`
    background-image: linear-gradient(
        ${SEND_GRADIENT_ANGLE},
        ${SEND_GRADIENT_START_COLOR} ${SEND_GRADIENT_START_OFFSET},
        ${SEND_GRADIENT_END_COLOR} ${SEND_GRADIENT_END_OFFSET}
    );
`;

export const SEND_GRADIENT_HOVER = css`
    background-image: linear-gradient(
        ${SEND_GRADIENT_ANGLE},
        ${SEND_GRADIENT_HOVER_START_COLOR} ${SEND_GRADIENT_START_OFFSET},
        ${SEND_GRADIENT_HOVER_END_COLOR} ${SEND_GRADIENT_END_OFFSET}
    );
`;

export const SEND_GRADIENT_ACTIVE = css`
    background-image: linear-gradient(
        ${SEND_GRADIENT_ANGLE},
        ${SEND_GRADIENT_ACTIVE_START_COLOR} ${SEND_GRADIENT_START_OFFSET},
        ${SEND_GRADIENT_ACTIVE_END_COLOR} ${SEND_GRADIENT_END_OFFSET}
    );
`;

export const InputShell = styled(Flex)<{ $activated: boolean; $isLoading: boolean }>`
    align-self: center;
    box-sizing: border-box;
    flex-direction: row;
    align-items: flex-end;
    gap: 24px;
    width: calc(100% - 32px);
    min-width: 0;
    padding: 16px;
    overflow: hidden;
    border: 1px solid ${({ $isLoading }) => ($isLoading ? "transparent" : colorsPalettes.carbon[100])};
    border-radius: 24px;
    background:
        linear-gradient(${colorsPalettes.carbon[0]}, ${colorsPalettes.carbon[0]}) padding-box,
        linear-gradient(
                ${SEND_GRADIENT_ANGLE},
                ${SEND_GRADIENT_START_COLOR} ${SEND_GRADIENT_START_OFFSET},
                ${SEND_GRADIENT_END_COLOR} ${SEND_GRADIENT_END_OFFSET}
            )
            border-box;
    transition: box-shadow 0.15s ease;

    ${({ $activated }) => $activated && setElevation("Z2")}
`;

export const TextAreaColumn = styled(Flex)`
    flex: 1;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
    min-height: 40px;
`;

export const StyledTextarea = styled.textarea`
    box-sizing: border-box;
    display: block;
    width: 100%;
    min-height: 80px;
    max-height: ${MAX_TEXTAREA_HEIGHT_PX}px;
    margin: 0;
    padding: 0;
    overflow-y: auto;
    resize: none;
    border: none;
    outline: none;
    background: transparent;
    ${setFontVariant("body2", colorsPalettes.carbon[500])};

    &::placeholder {
        color: ${colorsPalettes.carbon[300]};
    }
`;

export const SendButton = styled.button<{ $canSend: boolean; $isLoading: boolean }>`
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: ${SEND_BUTTON_SIZE_PX}px;
    height: ${SEND_BUTTON_SIZE_PX}px;
    margin: 0;
    padding: 0;
    overflow: hidden;
    border: none;
    border-radius: ${SEND_BUTTON_BORDER_RADIUS_PX}px;
    cursor: ${({ $canSend, $isLoading }) => ($canSend || $isLoading ? "pointer" : "not-allowed")};
    background-color: ${({ $canSend, $isLoading }) =>
        $canSend || $isLoading ? "transparent" : colorsPalettes.carbon[100]};

    ${({ $canSend, $isLoading }) =>
        ($canSend || $isLoading) &&
        css`
            ${SEND_GRADIENT};

            &:hover {
                ${SEND_GRADIENT_HOVER};
            }

            &:active {
                ${SEND_GRADIENT_ACTIVE};
            }
        `}
`;

export const StopIcon = styled.span`
    width: ${STOP_ICON_SIZE_PX}px;
    height: ${STOP_ICON_SIZE_PX}px;
    border-radius: ${STOP_ICON_BORDER_RADIUS_PX}px;
    background-color: ${colorsPalettes.carbon[0]};
`;
